import React, { useState, useContext } from "react";
import PanoramaContext from "./Context";

import { ReactComponent as CloseSvg } from "../../../assets/auth/login-close.svg";

import { ReactComponent as ArrowLeftCircleSvg } from "../../../assets/newProject/arrow-left-circle-white.svg";
import { ReactComponent as ArrowRightCircleSvg } from "../../../assets/newProject/arrow-right-circle-white.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

const assetsURI = import.meta.env.ASSETS_URI;

const FloorPlan = () => {
  const [init, setInit] = useState(undefined);

  const { floorPlans, closeOverlay } = useContext(PanoramaContext);

  const handleCloseClick = () => {
    closeOverlay();
  };

  return (
    <div className="pannellum-floor-plans">
      <div className="pannellum-floor-plans-content">
        <div className="pannellum-floor-plans-header">
          <span className="pannellum-floor-plans-header__title">
            Floor Plans
          </span>
          <CloseSvg
            className="pannellum-floor-plans-header__close"
            height={15}
            onClick={handleCloseClick}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexGrow: 1,
            gap: 8,
            width: "100%",
            height: "90dvh",
          }}
        >
          <ArrowLeftCircleSvg
            className="pannellum-floor-plans-content-types__arrow--left"
            width={48}
            style={{ cursor: "pointer" }}
          />
          <Swiper
            className="pannellum-floor-plans-content-types"
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            navigation={{
              enabled: true,
              prevEl: ".pannellum-floor-plans-content-types__arrow--left",
              nextEl: ".pannellum-floor-plans-content-types__arrow--right",
            }}
            speed={600}
            onInit={() => setInit(true)}
            loop={true}
            pagination={{
              clickable: true,
            }}
          >
            {floorPlans.map((p) => {
              return (
                <SwiperSlide key={p._id}>
                  <div className="pannellum-floor-plans-content-types-item">
                    <img
                      className="pannellum-floor-plans-content-types-item__image"
                      src={`${assetsURI}/${p.file}`}
                    />
                    <span className="pannellum-floor-plans-content-types-item__name">
                      {p.name}
                    </span>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <ArrowRightCircleSvg
            className="pannellum-floor-plans-content-types__arrow--right"
            width={48}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
    </div>
  );
};

export default FloorPlan;
